module.exports = __webpack_public_path__ + "static/img/ad_card_new.5b278df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc_diabetes/ad_card_new.png
// module id = qEkl
// module chunks = 0